import { Box } from '@components/Box';

import {
  AvailabilityButtonContainer,
  StyledButtonUnavailable,
  StyledInvite,
  Styledtext,
} from '../styles';

type InvitedBoxUnavailableUsProps = {
  props: SubmissionDetails | SubmissionDetailsMisc;
  isMobileDevice: boolean;
  formattedDate: string;
  handleAvailable: () => void;
};
export const InvitedBoxUnavailableUs = ({
  props,
  isMobileDevice,
  formattedDate,
  handleAvailable,
}: InvitedBoxUnavailableUsProps) => {
  return (
    <div style={{ ...(isMobileDevice ? { padding: 16 } : {}) }}>
      <Box style={{ marginTop: !isMobileDevice && '16px', padding: '24px' }}>
        <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 16 }}>
          {formattedDate}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <StyledInvite style={{ marginBottom: '16px' }}>
            You have responded as “Unavailable” for{' '}
            {props?.project_name +
              (props?.related_column_values?.Role
                ? ' | ' + props?.related_column_values?.Role
                : '')}
          </StyledInvite>
        </div>
        <Styledtext style={{ marginBottom: '16px' }}>
          Thank you for responding! Telling us you are “Unavailable” will never
          affect your ability to book future work. We appreciate the response!
        </Styledtext>
        <Styledtext>
          Need to change your availability? You can still do that here:
        </Styledtext>
        <AvailabilityButtonContainer>
          <StyledButtonUnavailable
            style={{ opacity: props.is_archived && '0.4' }}
            disabled={props.is_archived}
            onClick={() => handleAvailable()}
          >
            I am Available
          </StyledButtonUnavailable>
        </AvailabilityButtonContainer>
      </Box>
    </div>
  );
};
